
import Vue, { PropType } from 'vue'
import { Toilet } from '@/models'

import ToiletListHeader from './ToiletListHeader.vue'
import ToiletListItem from './ToiletListItem.vue'

export default Vue.extend({
  name: 'ToiletList',

  props: {
    toilets: Array as PropType<Array<Toilet>>,
  },

  components: {
    ToiletListHeader,
    ToiletListItem
  },
})
